import { alphabetise } from "../logic/Sorter"

const Genres = {
    list: [
        {
            code: "war",

            small_image: "war",
            small_image_alt: 'Eight soldiers with rifles on a beach facing an explosion',
            small_image_position: 'center 63%',
            large_image_code: 'into-egypt',
            large_image_alt: 'Drawing of a young soldier with a bayonet looking at a man.',

            intro: 'From Russia, to the U.S. and to France, Bierce, Maupassant and others tell of the worst that can come from conflict.',
            stories: ['Cain', 'Beware of the Dog', 'An Occurrence at Owl Creek Bridge'],

            hue: 1, colour: "hsl(0deg 100% 23%)",
        },
        {
            code: "horror",

            small_image: "hand",
            small_image_alt: "A large hand, palm up with tense fingers. Graphite filter.",
            large_image_code: 'the-monkeys-paw',
            large_image_alt: "Drawing of an old man and woman in a room looking very distressed.",

            intro: 'Hands walking on their own, a stalking hound in the night or a sinister black cat. Read after dark.',
            stories: ['The Hand', 'The Black Cat', 'The Horrible'],

            hue: 0, colour: "hsl(0deg 100% 0%)",
        },
        {
            code: "adventure",

            small_image: "lost",
            small_image_position: 'bottom',
            large_image_code: 'the-most-dangerous-game',
            large_image_alt: 'A drawing of a man in safari gear smoking a cigarrete under a tree in which a man hides.',


            intro: 'Journey through the cold winters of Jack London, the alien landscapes of Clark Ashton Smith, and the exotic jungles of H. G. Wells.',
            stories: ['The Country of the Blind', 'The Unexpected', 'The Most Dangerous Game'],

            hue: 20, colour: "hsl(20deg 100% 35%)",
        },
        {
            code: "childrens",
            small_image: "rabbit",
            small_image_alt: "A rabbit, looking nervous. Graphite filter.",
            small_image_position: '50% 33%',
            large_image_code: 'the-emperors-new-clothes',
            large_image_alt: "A king in a bare gown with no pants walks with his entourage in front of a crowd.",

            stories: ['The Emperor’s New Clothes', 'Honor Among Sportsmen', 'Hansel and Gretel'],
            intro: 'Fairy tales and fables of talking rabbits and mischievous children from the sweet-hearted minds of Beatrix Potter and Flora Annie Steel, and the darker thoughts of the Brothers Grimm.',
            hue: 39, colour: "hsl(39deg 100% 35%)",
        },
        {
            code: "tragedy", hue: 190, colour: "hsl(190deg 100% 22%)",
            small_image: "grave",
            small_image_alt: 'A stone grave with an wreath shape embossed upon it. Graphite filter.',
            small_image_position: '50% 10%',
            large_image_code: 'misery',
            large_image_alt: 'A hermit-like man lying on a horse.',

            intro: 'Lost love, failed ambition and stricken families. Steel your heart and read of the depths to which a human’s despair can swim.',
            stories: ['“allez!”', 'Misery', 'No Place for a Woman'],
        },
        {
            code: "gothic",
            small_image: "gothic",
            small_image_alt: "A spired cathedral looming large.",
            large_image_code: 'in-the-vault',
            large_image_alt: "Drawing of a man with his upper body hanging over a door and reaching out.",


            intro: 'Ghosts from Dickens, and murderers from Poe. Graveyards, medical procedures, plagues, burials and insanity.',
            stories: ['The Signal Man', 'The Cask of Amontillado', 'The Yellow Wallpaper'],

            hue: 0, colour: "hsl(0deg 0% 34%)",
        },
        {
            code: "sci-fi",

            small_image: "blastoff",
            small_image_alt: 'A short rocket launching into space amidst smoke. Graphite filter.',
            small_image_position: 'center 28%',
            large_image_code: 'the-shape-of-things',
            large_image_alt: 'Drawing of a man in pilot gear and a woman in a vehicle.',

            intro: 'A distant star, Jupiter’s moon, the near future or the far. Read of the discovery of new worlds and new technologies, and the consequences that they bring.',
            stories: ['2BR02B', 'The Nothing Equation', 'A Guest of Ganymede'],

            hue: 100, colour: "hsl(100deg 100% 36%)",

        },
        {
            code: "poetry", hue: 39, colour: "hsl(39deg 77% 25%)",
            small_image: "four",
            small_image_alt: "Four birds in the distance. Graphie Filter.",

            large_image_code: 'alone',
            large_image_alt: "A man with a billowing coat looks at a spectral-faced cloud.",

            intro: 'The troubled Poe, the dramatic Paterson, the grateful Henley, and others.',
            stories: ['Clancy of the Overflow', 'Invictus', 'The Raven'],

        },
        {
            code: "literary",
            small_image: "anguish",
            small_image_alt: "A woman clutching her face.",
            large_image_code: 'my-uncle-jules',
            large_image_alt: "Drawing of a crowd watching an arriving ship",
            large_image_position: 'center 44%',

            intro: 'Delve into the imperfect and unfair workings of society and the impious, inner thoughts of the people within them.',
            stories: ['My Uncle Jules', 'Black Fog', 'The Mantle'],
            
            hue: 240, colour: "hsl(240deg 70% 35%)", 
        },
        {
            code: "mystery", 
            small_image: "detective",
            small_image_alt: "A silhouetted man in a brimmed hat.",
            large_image_code: 'the-adventure-of-charles-augustus-milverton',
            large_image_alt: "Drawing of a man in a robe and top hat stands in the shadows with his hands clasped.",
            large_image_position: 'center 10%',

            intro: 'Why does the man upstairs never, ever leave his room? Is the man in the magic shop capable of more than mere tricks? What is within the tunnel from whence come screams and wind?',
            stories: ['Cool Air', 'The Magic Shop', 'The Nameless City'],
 
            hue: 268, colour: "hsl(268deg 100% 22%)",
        },
        {
            code: "fantasy", 
            small_image: "crown",
            small_image_alt: 'A kings crown sitting on a stool. Graphite filter.',
            large_image_code: 'the-phoenix-on-the-sword',
            large_image_alt: 'Drawing of a man in roman armour holding an axe as a wolf-featured man leans over him.',

            intro: 'Dreams of love and nightmares of monsters. Worlds beneath us, above us, from other dimensions and buried in our thoughts.',
            stories: ['A Vintage From Atlantis', 'The Pearl of Love', 'Celephaïs'],

            hue: 330, colour: "hsl(330deg 100% 35%)",
        },
        {
            code: "quirky",

            small_image: "oven",
            small_image_alt: "A vintage oven with a teapot on the stove. Graphite filter.",
            small_image_position: '50% 36%',
            large_image_code: 'the-man-who-could-imitate-a-bee',
            large_image_alt: "A sketch of a party of six people sitting together with a man in the middle with pursed lips as if whistling.",

            intro: 'Read from stories with scenes of a man running through the night with a wax figurine in a wheelbarrow, an advertisement for a 2 for 1 coffin sale, or a man hearing his own obituary.',
            stories: ['The Man Who Could Imitate a Bee', 'And All the Earth a Grave', 'Johnny Pye and the Fool-Killer'],

            hue: 144, colour: "hsl(144deg 100% 22%)",
        }
    ].sort((a, b) => alphabetise(a.code, b.code)),

    get_style: hue => {
        if (!hue) return ''
        return 'filter: grayscale(1) invert() sepia() saturate(150%) hue-rotate(' + ((hue + 140) % 360) + 'deg) invert(1) brightness(1.2);'
    },

    get_faint_colour: genre => {
        let hue = Genres.list.find(g => g.code == genre).hue
        let saturation = hue !== 0 ? 100 : 0
        let lightness = hue !== 0 ? 50 : 0
        if (genre == 'gothic') lightness = 50
        let colour = `hsl(${hue}, ${saturation}%, ${lightness}%, 25%)`
        return colour
    }
}

export default Genres